import {t} from 'i18next';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {Dialog} from 'primereact/dialog';
import {Message} from 'primereact/message';
import ActionButton from '../../components/ActionButton';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import MobileUserService from '../../services/MobileUserService';
import BaseContainer from '../../baseContainers/BaseContainer';

class ResetWalletPointsDialog extends BaseContainer {
    constructor(props) {
        super(props);
        this.service = new MobileUserService();
        this.state = {
            dateStart: null,
            dateEnd: null,
            submitting: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCalendarChange = this.handleCalendarChange.bind(this);
    }

    handleCalendarChange(inputType, parameters, event, onAfterStateChange, stateField) {
        this.handleChange(inputType, parameters, event, onAfterStateChange, stateField ?? '');
    }

    handleSubmit() {
        const {criteria, onSuccess, onHide, showErrorMessage, showSuccessMessage, blockUi, unblockUi} = this.props;
        const {dateStart, dateEnd} = this.state;

        if (!dateStart || !dateEnd) {
            showErrorMessage(t('mobileUser.resetPoints.dateRequired'));
            return;
        }

        const payload = {
            dateStart: moment(dateStart).format('YYYY-MM-DD'),
            dateEnd: moment(dateEnd).format('YYYY-MM-DD'),
            name: criteria?.name || '',
            email: criteria?.email || '',
            status: criteria?.status?.enumValue,
            onlyInvitedUsers: criteria?.onlyInvitedUsers || false,
        };

        blockUi();
        this.setState({submitting: true});
        this.service
            .resetWalletPoints(payload)
            .then((response) => {
                showSuccessMessage(
                    t('mobileUser.resetPoints.success', {
                        users: response.affectedUsers,
                        events: response.zeroedEvents,
                        points: response.totalPointsRemoved,
                    })
                );
                if (onSuccess) {
                    onSuccess();
                }
                onHide();
            })
            .catch((err) => {
                showErrorMessage(err.message || t('mobileUser.resetPoints.error'));
            })
            .finally(() => {
                this.setState({submitting: false});
                unblockUi();
            });
    }

    renderFooter() {
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton
                    label={t('details.cancel')}
                    variant='accent gray'
                    handleClick={this.props.onHide}
                    disabled={this.state.submitting}
                />
                <ActionButton
                    label={t('mobileUser.resetPoints.confirm')}
                    className='red-button'
                    handleClick={this.handleSubmit}
                    disabled={this.state.submitting}
                />
            </div>
        );
    }

    render() {
        const {visible, onHide} = this.props;
        return (
            <Dialog
                header={t('mobileUser.resetPoints.header')}
                visible={visible}
                onHide={onHide}
                footer={this.renderFooter()}
                style={{width: '520px'}}
            >
                <Message
                    severity='warn'
                    className='w-100 mb-3'
                    text={t('mobileUser.resetPoints.warning')}
                />
                <p className='mb-3'>{t('mobileUser.resetPoints.description')}</p>
                <InputCalendarRangeComponent
                    key='reset-wallet-points-range'
                    idFrom='dateStart'
                    idTo='dateEnd'
                    nameFrom='dateStart'
                    nameTo='dateEnd'
                    label=''
                    labelFrom={t('mobileUser.resetPoints.dateFrom')}
                    labelTo={t('mobileUser.resetPoints.dateTo')}
                    colClass='col-12'
                    from={this.state.dateStart}
                    to={this.state.dateEnd}
                    validator={this.validator}
                    onChange={this.handleCalendarChange}
                    stateField=''
                    viewMode='NEW'
                    showIcon
                    dateFormatMoment='DD-MM-YYYY'
                    validatorsTo={`required|date|after_or_equal_datetime~${moment(
                        this.state.dateStart ? this.state.dateStart : new Date()
                    ).format('DD-MM-YYYY')}`}
                    placeholderFrom='dd-mm-rrrr'
                    placeholderTo='dd-mm-rrrr'
                    validatorsToType='after_or_equal_datetime'
                />
            </Dialog>
        );
    }
}

ResetWalletPointsDialog.propTypes = {
    visible: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    criteria: PropTypes.object.isRequired,
    onSuccess: PropTypes.func,
    showErrorMessage: PropTypes.func.isRequired,
    showSuccessMessage: PropTypes.func.isRequired,
    blockUi: PropTypes.func.isRequired,
    unblockUi: PropTypes.func.isRequired,
};

export default withTranslation()(ResetWalletPointsDialog);
